import Box from "@mui/material/Box";
import CellCheckboxAMPUTFixPrice from "../components/UI/table/warehouse/material/arrival/CellCheckboxAMPUTFixPrice";
import CellCheckboxAMPUTPrice from "../components/UI/table/warehouse/material/arrival/CellCheckboxAMPUTPrice";
import CellWithPairCurrency from "../components/UI/сell/CellWithPairCurrency";
import React, {useMemo} from "react";
import {Stack, Tooltip} from "@mui/material";
import {Link} from "react-router-dom";

const EllipsisCell = ({value, maxWidth}) => {
    if (value == null || value === '') {
        return null;
    }
    return (
        <Tooltip arrow placement="bottom" title={value}>
            <Box
                sx={{
                    width: maxWidth ? `${maxWidth}px` : "100%",
                    maxWidth: maxWidth ? `${maxWidth}px` : "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {value}
            </Box>
        </Tooltip>
    );
};

export const ArrivalMaterialPriceUnitColumns = ({
                                                    data,
                                                    setData,
                                                    params,
                                                    alternativeCurrency,
                                                    baseCurrency,
                                                    slabMaterial,
                                                    currencyMap,
                                                    filteredData
                                                }) => {
    const sumCurrentCurrency = useMemo(
        () => data.reduce((acc, mEU) => {
            if (mEU.amountInCurrencyArrival != null) {
                return acc + mEU.amountInCurrencyArrival;
            }
            return acc;
        }, 0),
        [data]
    );
    return useMemo(() => {
        const baseColumns = [
            {
                id: 'articleNumberSupplier',
                header: 'Артикул пост.',
                accessorKey: 'supplierMaterial.article',
                size: 100,
                minSize: 90,
                maxSize: 110,
                grow: false,
                muiTableHeadCellProps: {
                    sx: {width: 100, minWidth: 90, maxWidth: 110},
                },
                muiTableBodyCellProps: {
                    sx: {width: 100, minWidth: 90, maxWidth: 110},
                },
                Cell: ({cell}) => <EllipsisCell value={cell.getValue()} maxWidth={100}/>,
            },
            {
                id: 'materialNameSupplier',
                header: 'Наименование пост.',
                accessorKey: 'supplierMaterial.materialNameSupplier',
                size: 120,
                minSize: 100,
                maxSize: 140,
                grow: false,
                muiTableHeadCellProps: {
                    sx: {width: 120, minWidth: 100, maxWidth: 140},
                },
                muiTableBodyCellProps: {
                    sx: {width: 120, minWidth: 100, maxWidth: 140},
                },
                Cell: ({cell}) => <EllipsisCell value={cell.getValue()} maxWidth={120}/>,
            },
            {
                id: 'articleNumber',
                header: 'Артикул',
                accessorKey: 'materialOrganizationOption.articleNumber',
                size: 140,
                minSize: 120,
                maxSize: 180,
                grow: false,
                muiTableHeadCellProps: {
                    sx: {width: 140, minWidth: 120, maxWidth: 180},
                },
                muiTableBodyCellProps: {
                    sx: {width: 140, minWidth: 120, maxWidth: 180},
                },
                Cell: ({cell}) => <EllipsisCell value={cell.getValue()} maxWidth={140}/>,
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'materialOrganizationOption.name',
                size: 220,
                minSize: 180,
                maxSize: 280,
                grow: false,
                enableEditing: false,
                muiTableHeadCellProps: {
                    sx: {width: 220, minWidth: 180, maxWidth: 280},
                },
                muiTableBodyCellProps: {
                    sx: {width: 220, minWidth: 180, maxWidth: 280},
                },
                Cell: ({cell}) => <EllipsisCell value={cell.getValue()} maxWidth={220}/>,
            },
            {
                id: 'unit.name',
                header: 'Ед. изм.',
                accessorKey: 'materialOrganizationOption.unit.name',
                minSize: 5,
                maxSize: 5,
            },
            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 5,
                maxSize: 5,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/materials-price-unit-arrival/' + params.arrivalMaterialId + '/' + params.arrivalMaterial + '/' + params.currentCurrency + '/' + params.supplierId + '/' + params.warehouseId + '/reserve-arrival/' + row.original.id + "/" + row.original.materialOrganizationOption?.typeMaterial + "/" + row.original.materialOrganizationOption?.unit.name}>{row.original.quantity?.toFixed(3)}</Link>
                ),
            },
            {
                id: 'amountInCurrencyArrival',
                header: `Сумма ${params.currentCurrency}`,
                accessorKey: 'amountInCurrencyArrival',
                minSize: 8,
                maxSize: 8,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumCurrentCurrency?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {params.currentCurrency}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'priceInCurrencyArrival',
                header: `Цена ${params.currentCurrency}`,
                accessorKey: 'materialPriceInCurrencyArrival.price',
                minSize: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
            },
            {
                id: 'exchangeRateToBaseCurrencyBaseMaterials',
                header: 'курс БВ',
                accessorKey: 'exchangeRateToBaseCurrencyBaseMaterials',
                minSize: 50,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                Header: ({column}) => <Box sx={{whiteSpace: 'pre-wrap', padding: 0}}>{column.columnDef.header}</Box>,
            },
            {
                id: 'priceInCurrencyBase',
                header: `Цена ${baseCurrency}`,
                accessorKey: 'materialPriceInCurrencyBase.price',
                minSize: 8,
                maxSize: 8,
                enableEditing: false,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
            },
            {
                id: 'exchangeRateToAlternativeCurrencyBaseMaterials',
                header: 'курс АВ',
                accessorKey: 'exchangeRateToAlternativeCurrencyBaseMaterials',
                maxSize: 120,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                Header: ({column}) => <Box sx={{whiteSpace: 'pre-wrap', padding: 0}}>{column.columnDef.header}</Box>,
            },
            {
                id: 'priceInCurrencyAlternative',
                header: `Цена ${alternativeCurrency}`,
                accessorKey: 'materialPriceInCurrencyAlternative.price',
                minSize: 8,
                maxSize: 8,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
                enableEditing: false,
            },
            {
                id: 'basePrice',
                header: 'Баз. цена',
                accessorKey: 'supplierMaterial.basePrice.price',
                size: 8,
                Cell: ({cell, row}) => {
                    const basePrice = row.original.supplierMaterial?.basePrice || null;
                    return basePrice === null ? '' : (
                        <CellCheckboxAMPUTFixPrice
                            price={basePrice}
                            fixPrice={row.original.supplierMaterial.fixPrice}
                            currencyMap={currencyMap}
                        />
                    );
                },

                minSize: 8,
                maxSize: 8,
            },
            {
                id: 'realBasePrice',
                header: 'Тек. цена',
                accessorKey: 'materialPriceInRealBasePrice.price',
                size: 8,
                Cell: ({row}) => <CellCheckboxAMPUTPrice
                    price={row.original.materialPriceInRealBasePrice}
                    currencyMap={currencyMap}
                />,
                minSize: 8,
                maxSize: 8,
            },
            {
                id: 'priceIncreaseInBasePrice',
                header: 'Расх., %',
                accessorKey: 'priceIncreaseInBasePrice',
                size: 8,
                minSize: 8,
                maxSize: 8,
                Cell: ({cell}) => {
                    const value = cell.getValue()

                    if (value < 0) {
                        return (Math.ceil((value * -1) * 1000) / 1000) * -1
                    } else {
                        return Math.ceil(value * 1000) / 1000
                    }
                },
            },
            {
                id: 'exchangeRateToBasePrice',
                header: 'курс БЦ',
                accessorKey: 'exchangeRateToBasePrice',
                maxSize: 120,
                Header: ({column}) => <Box sx={{whiteSpace: 'pre-wrap', padding: 0}}>{column.columnDef.header}</Box>,
                Cell: ({cell, row}) => cell.getValue() === null ? '' : (<CellWithPairCurrency
                    number={cell.getValue().toFixed(3)}
                    currency1={params.currentCurrency}
                    currency2={currencyMap.get(row.original.supplierMaterial.basePrice.currencyId)?.curAbbreviation}
                />),
            },
            {
                id: 'coefficientCurrencyBasePrice',
                header: 'Кф. курса БЦ',
                accessorKey: 'coefficientCurrencyBasePrice',
                minSize: 5,
                maxSize: 5,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                },
            },
            {
                id: 'losses',
                header: `Потери ${alternativeCurrency}`,
                accessorKey: 'losses',
                minSize: 8,
                maxSize: 8,
                Cell: ({cell}) => {
                    const value = cell.getValue()
                    if (value < 0) {
                        return (Math.ceil((value * -1) * 1000) / 1000) * -1
                    } else {
                        return Math.ceil(value * 1000) / 1000
                    }
                },
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
            },
        ];

        if (slabMaterial) {
            baseColumns.splice(3, 0, {
                id: 'length',
                header: 'L',
                accessorKey: 'length',
                minSize: 15,
                maxSize: 15,
            });
        }

        if (slabMaterial) {
            baseColumns.splice(4, 0, {
                id: 'width',
                header: 'H',
                accessorKey: 'width',
                minSize: 15,
                maxSize: 15,
            });
        }

        return baseColumns;

    }, [data, setData, params, alternativeCurrency, baseCurrency, slabMaterial, currencyMap,filteredData]);
};